<template>
  <div class="ud-body">
    <!-- 搜索表单 -->
    <a-card :bordered="true">
      <a-form
        :model="where"
        :label-col="{ md: { span: 6 }, sm: { span: 24 } }"
        :wrapper-col="{ md: { span: 18 }, sm: { span: 24 } }"
      >
        <a-row>
          <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item label="优惠券名称">
              <a-input
                v-model:value.trim="where.name"
                placeholder="请输入优惠券名称"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item label="最低消费">
              <a-input
                v-model:value.trim="where.minPrice"
                placeholder="请输入最低消费"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item label="等级权重:">
              <a-select
                allow-clear
                placeholder="请选择等级权重"
                v-model:value="where.weight"
              >
                <a-select-option
                  v-for="item in weightList"
                  :key="item.dictDataCode"
                  :value="item.dictDataCode"
                >
                  {{ item.dictDataName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item class="ud-text-right" :wrapper-col="{ span: 24 }">
              <a-space>
                <a-button type="primary" @click="reload">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <!-- 表格 -->
      <ud-pro-table
        ref="table"
        row-key="couponId"
        :datasource="datasource"
        :columns="columns"
        v-model:selection="selection"
        :scroll="{ x: 'max-content' }"
        @change="onTableChange"
      >
        <template #toolbar>
          <a-space>
            <a-button type="primary" @click="openEdit()">
              <template #icon>
                <plus-outlined />
              </template>
              <span>新建</span>
            </a-button>
            <a-button type="primary" danger @click="removeBatch">
              <template #icon>
                <delete-outlined />
              </template>
              <span>删除</span>
            </a-button>
          </a-space>
        </template>
        <template #couponType="{ record }">
          <a-tag  color="green" v-if="record.couponType === 10">满减券</a-tag>
          <a-tag color="blue" v-if="record.couponType === 20">折扣券</a-tag>
        </template>
        <template #expireType="{ record }">
          <a-tag  color="green" v-if="record.expireType === 10">领取后生效</a-tag>
          <a-tag color="blue" v-if="record.expireType === 20">固定时间</a-tag>
        </template>
        <!-- <template #status="{ record }">
          <a-tag  color="green" v-if="record.status === 1">显示</a-tag>
          <a-tag v-if="record.expireType === 20">隐藏</a-tag>
        </template> -->
        <template #action="{ record }">
          <a-space>
            <a @click="openDetail(record)">详情</a>
            <a @click="openEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定要删除此项吗？" @confirm="remove(record)">
              <a class="ud-text-danger">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </ud-pro-table>
    </a-card>
    <!-- 编辑 -->
    <CorpCouponEdit
      v-model:visible="showEdit"
      :corpId="corpId"
      :data="current"
      @done="reload"
    />
    <!-- 详情弹窗 -->
    <CorpCouponDetail v-model:visible="showDetail" :data="current || {}" />
  </div>
</template>

<script>
import * as corpCouponApi from '@/api/corp/corpCoupon'
// import * as dictDataApi from '@/api/sys/dictData'
import CorpCouponEdit from './corpCoupon-edit.vue'
import CorpCouponDetail from './corpCoupon-detail'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons-vue'
export default {
  name: 'memberGradeIndex',
  components: {
    PlusOutlined,
    DeleteOutlined,
    CorpCouponEdit,
    CorpCouponDetail
  },
  props: {
    corpId: Number
  },
  data() {
    return {
      // 表格列配置
      columns: [
        {
          title: '优惠券名称',
          dataIndex: 'name',
          fixed: 'left'
        },
        {
          title: '最低消费',
          dataIndex: 'minPrice'
        },
        {
          title: '优惠券类型',
          dataIndex: 'couponType',
          slots: { customRender: 'couponType' }
        },
        {
          title: '免减金额',
          dataIndex: 'reducePrice'
        },
        {
          title: '折扣率',
          dataIndex: 'discount'
        },
        {
          title: '到期类型',
          dataIndex: 'expireType',
          slots: { customRender: 'expireType' }
        },
        {
          title: '有效天数',
          dataIndex: 'expireDay'
        },
        {
          title: '优惠券时间',
          dataIndex: 'couponTime'
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          slots: { customRender: 'status' }
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime'
        // },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          sorter: true
        },
        {
          title: '操作',
          key: 'action',
          width: '150px',
          align: 'center',
          slots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      // 表格搜索条件
      where: {corpId:this.getCorpId()},
      // 表格排序条件
      order: {},
      // 表格选中数据
      selection: [],
      // 是否显示编辑弹窗
      showEdit: false,
      // 是否显示详情弹窗
      showDetail: false,
      // 当前编辑数据
      current: null,
      // 编辑表单提交状态
      editLoading: false,
      // 是否显示用户导入弹窗
      showImport: false,
      // 商品名称list
      sortList: [],
      // 等级权重字典项
      weightList: []
      // corpId: 0
    }
  },
  watch: {
    corpId() {
      if (this.corpId) {
        this.reload()
      }
    }
  },
  mounted() {
    
    // this.queryDataRoles()
  },
  methods: {
    datasource(option, callback) {
      corpCouponApi
        .page({
          ...this.where,
          sort: 'createTime',
          order: 'desc',
          page: option.page,
          limit: option.limit
        })
        .then((res) => {
          if (res.code === 0) {
            // res.data.map((item) => {
            //   if (item.state === '0') {
            //     item.stateName = '不显示'
            //   } else if (item.state === '1') {
            //     item.stateName = '显示'
            //   }
            // })
            console.log('res210', res.data)

            callback(res.data, res.count)
          } else {
            callback(res.msg)
          }
        })
        .catch((e) => {
          callback(e.message)
        })
    },
    /* 表格分页、排序、筛选改变回调 */
    onTableChange(pagination, filters, sorter) {
      if (sorter.order) {
        this.order.sort = sorter.field
        this.order.order = { ascend: 'asc', descend: 'desc' }[sorter.order]
      } else {
        this.order = {}
      }
      // this.reload()
    },
    /* 刷新表格 */
    reload() {
      this.selection = []
      this.$refs.table.reload({ page: 1 })
    },
    /* 重置搜索 */
    reset() {
      const corpId = this.getCorpId()
      this.where = {corpId}
      this.$nextTick(() => {
        this.reload()
      })
    },
    /* 删除单个 */
    remove(row) {
      const hide = this.$message.loading('请求中..', 0)
      corpCouponApi
        .deleteById(row.couponId)
        .then((res) => {
          hide()
          if (res.code === 0) {
            this.$message.success(res.msg)
            this.reload()
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          hide()
          this.$message.error(e.message)
        })
    },
    /* 批量删除 */
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请至少选择一条数据')
        return
      }
      this.$confirm({
        title: '提示',
        content: '确定要删除选中的项吗?',
        maskClosable: true,
        onOk: () => {
          const hide = this.$message.loading('请求中..', 0)
          const data = { data: this.selection.map((d) => d.couponId) }
          corpCouponApi
            .deleteBatch(data)
            .then((res) => {
              hide()
              if (res.code === 0) {
                this.$message.success(res.msg)
                this.reload()
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch((e) => {
              hide()
              this.$message.error(e.message)
            })
        }
      })
    },
    /* 打开编辑弹窗 */
    openEdit(row) {
      // console.log('row325', row)
      // console.log('this.corpId326', this.corpId)
      this.current = row
      // this.corpId = row.corpId
      this.showEdit = true
    },
    /* 详情 */
    openDetail(row) {
      this.current = row
      this.showDetail = true
    }
    // 获取商品名称List
    // querysortList() {
    //   pointsCategoryApi
    //     .all()
    //     .then((res) => {
    //       if (res.code === 0) {
    //         this.sortList = res.data
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //     .catch((e) => {
    //       this.$message.error(e.message)
    //     })
    // },
    // 等级权重字典
    // queryDataRoles() {
    //   dictDataApi
    //     .querydictdata('gradeWeight')
    //     .then((res) => {
    //       if (res.code === 0) {
    //         this.weightList = res.data
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //     .catch((e) => {
    //       this.$message.error(e.message)
    //     })
    // }
  }
}
</script>

<style scoped>
</style>
